<template>
  <div
    class="page-block__inner"
    @dragover.prevent="onFileDragover"
    @drop.prevent="onOutsideFileDrop">
    <release-step-area
      v-if="status===0 && !confirm"
      :index="2">
      ジャケット画像、リリース情報、楽曲情報を登録してください
    </release-step-area>
    <div
      v-if="status===0 && !confirm"
      class="release-btn-area">
      <div class="release-btn-area__column">
        <div class="c-gray-box__title">
          <svg
            class="icon-add_jacket svg-icon"
            viewBox="0 0 26.5 24.994">
            <path
              class="color1"
              d="M14.436,0h-.012L1.458,2A1.5,1.5,0,0,0,0,3.494v18a1.479,1.479,0,
              0,0,1.414,1.494h.01L14.5,24.994a1.5,1.5,0,0,0,1.5-1.5v-22A1.51,1.51,
              0,0,0,14.436,0ZM15,23.494a.5.5,0,0,1-.424.506L1.5,21.994a.5.5,0,0,
              1-.5-.5v-18a.5.5,0,0,1,.5-.5l13-2a.5.5,0,0,1,
              .5.5Zm11.5-21v20h-10v-1h9v-18h-9v-1h10ZM16.5,20a7.571,7.571,0,0,0,
              0-15.009L16.629,4a8.571,8.571,0,0,1,0,16.991Zm1.417-6.978A1.63,
              1.63,0,0,0,16.9,10.953a.5.5,0,1,1,.323-.946,2.629,2.629,0,0,1,
              .017,4.97.5.5,0,0,1-.33-.944A1.623,1.623,0,0,0,17.913,13.021Z" />
          </svg>
          ジャケット画像の登録
        </div>
        <div class="c-gray-box__lead">
          配信するパッケージのジャケット画像を<br>
          アップロードして登録します。
        </div>
        <a
          class="c-btn"
          :class="{ 'c-btn--change': hasJacket }"
          href="#"
          @click.prevent="onAddJacketClicked">
          {{ hasJacket ? '変更する' : '登録する' }}
          <span class="c-btn__icon-arrow"></span>
        </a>
      </div>
      <div class="release-btn-area__column">
        <div class="c-gray-box__title">
          <svg
            class="icon-add_product svg-icon"
            viewBox="0 0 17.044 23.033">
            <path
              class="color1"
              d="M1.322,23.033a1.352,1.352,0,0,1-.328-.041,1.325,1.325,0,0,
              1-.968-1.54V1.507a1.057,1.057,0,0,1,0-.274A1.4,1.4,0,0,1,
              1.585.011l11.148,0,.146.146c4.042,4.036,4.042,4.036,4.084,4.112a.5.5,0,
              0,1-.807.579c-.188-.193-3.141-3.142-3.837-3.837H1.526a.453.453,0,0,
              0-.354.079.4.4,0,0,0-.15.267l0,.154L1.01,21.631a.322.322,0,0,0,
              .392.392l.124-.016,14.105.011a.338.338,0,0,0,.406-.261.349.349,
              0,0,0,0-.144l-.011-.105-.014-14.5H12.526a2.917,2.917,0,0,
              1-2.494-2.421l-.006-3.079a.5.5,0,1,1,1,0v3a1.9,1.9,0,0,0,1.579,
              1.507l4.407-.007.014,15.453a1.362,1.362,0,0,1-.012.509,1.341,
              1.341,0,0,1-1.535,1.038H1.581A1.338,1.338,0,0,1,
              1.322,23.033Zm2.2-12.526h10v-1h-10Zm0,3h10v-1h-10Zm0,3h6v-1h-6Z" />
          </svg>
          リリース情報の登録
        </div>
        <div
          v-if="isBtoB"
          class="c-gray-box__lead">
          配信するパッケージのタイトルやジャンル、<br>レーベルなどを登録します。
        </div>
        <div
          v-else
          class="c-gray-box__lead">
          配信するパッケージのタイトルや<br>ジャンルなどを登録します。
        </div>
        <a
          class="c-btn"
          :class="{ 'c-btn--change': hasProduct }"
          href="#"
          @click.prevent="onAddProductClicked">
          {{ hasProduct ? '変更する' : '登録する' }}
          <span class="c-btn__icon-arrow"></span>
        </a>
      </div>
    </div>
    <div :class="[{'reverse': confirm},'release-info-wrapper']">
      <div class="release-add-song-area">
        <div class="release-add-song-area__column">
          <div v-if="!confirm">
            <div
              v-if="status === 0"
              class="c-gray-box__title">
              <svg
                class="icon-song svg-icon"
                viewBox="0 0 17.044 23.033">
                <path
                  class="color1"
                  d="M17.026,21.46a1.362,1.362,0,0,1-.012.509,1.34,1.34,0,
                  0,1-1.535,1.038H1.581a1.338,1.338,0,0,1-.259.026,1.352,
                  1.352,0,0,1-.328-.041,1.325,1.325,0,0,1-.968-1.54V1.507a1.057,
                  1.057,0,0,1,0-.274A1.387,1.387,0,0,1,.553.3,1.377,1.377,0,0,1,
                  1.585.011l11.148,0,.146.146c4.047,4.04,4.047,4.04,4.091,4.125a.5.5,
                  0,0,1-.815.564C16,4.68,13.84,2.526,12.319,1.007H1.526a.455.455,0,0,
                  0-.354.079.4.4,0,0,0-.15.267l0,.154L1.01,21.631a.322.322,0,0,0,
                  .392.392l.124-.016,14.105.011a.337.337,0,0,0,.406-.261.349.349,0,0,
                  0,0-.144l-.011-.105-.014-14.5H12.526a2.917,2.917,0,0,
                  1-2.494-2.421l-.006-3.079a.5.5,0,1,1,1,0v3a1.9,1.9,0,0,0,1.579,
                  1.507l4.407-.007Zm-14.5-3.3a2.2,2.2,0,0,1,1.866-1.919,1.907,1.907,0,
                  0,1,1.176.088V9.97a.415.415,0,0,1,.289-.391l6.087-2.072a.457.457,0,0,
                  1,.4.051.409.409,0,0,1,.184.339v7.464h-.015c0,.035.012.069.012.1a2.2,
                  2.2,0,0,1-1.866,1.919,2.394,2.394,0,0,1-.469.049h0A1.754,1.754,0,0,1,
                  9.114,17.1a1.256,1.256,0,0,1-.5-1.013,2.2,2.2,0,0,1,1.866-1.919,1.9,
                  1.9,0,0,1,1.179.091v-3.7L6.442,12.334v5.1H6.427c0,.036.012.07.012.106a2.2,
                  2.2,0,0,1-1.866,1.919,2.394,2.394,0,0,1-.469.049,1.755,1.755,0,0,
                  1-1.077-.338A1.254,1.254,0,0,1,2.527,18.157Zm9.129-2.691a.45.45,0,0,
                  0-.178-.368.88.88,0,0,0-.531-.151h0a1.53,1.53,0,0,0-1.464,1.137.443.443,
                  0,0,0,.178.368,1.032,1.032,0,0,0,.818.123A1.389,1.389,0,0,0,11.656,
                  15.466Zm-5.214-5.2v1.19l5.217-1.777V8.486ZM3.4,18.157a.441.441,0,0,0,
                  .178.367,1.028,1.028,0,0,0,.818.123,1.386,1.386,0,0,0,1.177-1.108.446.446,
                  0,0,0-.178-.367.874.874,0,0,0-.531-.152h0a1.378,1.378,0,0,0-.287.03A1.385,
                  1.385,0,0,0,3.4,18.157Z" />
              </svg>
              楽曲情報の登録
            </div>
            <div
              v-else
              class="c-gray-box__title u-text-align-left">
              <svg
                class="icon-song svg-icon"
                viewBox="0 0 17.044 23.033">
                <path
                  class="color1"
                  d="M17.026,21.46a1.362,1.362,0,0,1-.012.509,1.34,1.34,0,
                  0,1-1.535,1.038H1.581a1.338,1.338,0,0,1-.259.026,1.352,
                  1.352,0,0,1-.328-.041,1.325,1.325,0,0,1-.968-1.54V1.507a1.057,
                  1.057,0,0,1,0-.274A1.387,1.387,0,0,1,.553.3,1.377,1.377,0,0,1,
                  1.585.011l11.148,0,.146.146c4.047,4.04,4.047,4.04,4.091,4.125a.5.5,
                  0,0,1-.815.564C16,4.68,13.84,2.526,12.319,1.007H1.526a.455.455,0,0,
                  0-.354.079.4.4,0,0,0-.15.267l0,.154L1.01,21.631a.322.322,0,0,0,
                  .392.392l.124-.016,14.105.011a.337.337,0,0,0,.406-.261.349.349,0,0,
                  0,0-.144l-.011-.105-.014-14.5H12.526a2.917,2.917,0,0,
                  1-2.494-2.421l-.006-3.079a.5.5,0,1,1,1,0v3a1.9,1.9,0,0,0,1.579,
                  1.507l4.407-.007Zm-14.5-3.3a2.2,2.2,0,0,1,1.866-1.919,1.907,1.907,0,
                  0,1,1.176.088V9.97a.415.415,0,0,1,.289-.391l6.087-2.072a.457.457,0,0,
                  1,.4.051.409.409,0,0,1,.184.339v7.464h-.015c0,.035.012.069.012.1a2.2,
                  2.2,0,0,1-1.866,1.919,2.394,2.394,0,0,1-.469.049h0A1.754,1.754,0,0,1,
                  9.114,17.1a1.256,1.256,0,0,1-.5-1.013,2.2,2.2,0,0,1,1.866-1.919,1.9,
                  1.9,0,0,1,1.179.091v-3.7L6.442,12.334v5.1H6.427c0,.036.012.07.012.106a2.2,
                  2.2,0,0,1-1.866,1.919,2.394,2.394,0,0,1-.469.049,1.755,1.755,0,0,
                  1-1.077-.338A1.254,1.254,0,0,1,2.527,18.157Zm9.129-2.691a.45.45,0,0,
                  0-.178-.368.88.88,0,0,0-.531-.151h0a1.53,1.53,0,0,0-1.464,1.137.443.443,
                  0,0,0,.178.368,1.032,1.032,0,0,0,.818.123A1.389,1.389,0,0,0,11.656,
                  15.466Zm-5.214-5.2v1.19l5.217-1.777V8.486ZM3.4,18.157a.441.441,0,0,0,
                  .178.367,1.028,1.028,0,0,0,.818.123,1.386,1.386,0,0,0,1.177-1.108.446.446,
                  0,0,0-.178-.367.874.874,0,0,0-.531-.152h0a1.378,1.378,0,0,0-.287.03A1.385,
                  1.385,0,0,0,3.4,18.157Z" />
              </svg>
              楽曲情報
            </div>
            <div
              v-if="status===0"
              class="c-gray-box__lead">
              楽曲ファイルのアップロードや、楽曲タイトル、著作権情報、著作者などを登録します。<br />
            </div>
            <div
              v-if="status===0"
              class="c-table-caption">
              横にスクロールしてご覧ください
            </div>
            <div
              v-if="status===0"
              class="release-add-song-area__wrap">
              <table class="release-add-song-area__table">
                <thead class="release-add-song-area__thead">
                  <tr>
                    <th></th>
                    <th>ファイル形式</th>
                    <th>サンプルサイズ</th>
                    <th class="u-title-align-left">サンプルレート</th>
                    <th>チャンネル</th>
                    <th v-if="isBtoC">曲の長さ</th>
                  </tr>
                </thead>
                <tbody class="release-add-song-area__tbody">
                  <tr>
                    <td>通常</td>
                    <td>WAV形式</td>
                    <td>16bit</td>
                    <td class="u-title-align-left">44.1kHz</td>
                    <td>ステレオ</td>
                    <td v-if="isBtoC">10分以内</td>
                  </tr>
                  <tr>
                    <td>ハイレゾ</td>
                    <td>WAV形式</td>
                    <td>24bit</td>
                    <td class="u-title-align-left">
                      44.1kHz, 48kHz, 88.2kHz, 96kHz, 176.4kHz, 192kHz
                    </td>
                    <td>ステレオ</td>
                    <td v-if="isBtoC">10分以内</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div
            :class="{ 'form--error': errors }"
            class="release-status-area">
            <div
              v-if="hasTracks && status===0"
              class="c-gray-box__title c-gray-box__title--nolead u-text-align-left">
              楽曲情報の登録状況
            </div>
            <div
              v-if="type==='album'"
              class="release-status-area__tab-box">
              <ul class="release-status-area__tab">
                <li
                  v-for="(disc, index) in discs"
                  :key="`disc${index}`"
                  class="release-status-area__tab-item"
                  :class="{ current: currentDiscIndex === index }">
                  <a
                    href="#"
                    :class="{ 'disable-link': status > 0 && currentDiscIndex === index }"
                    @click.prevent="onDiscTabClicked(index)">
                    Disc{{ index + 1 }}
                    <span
                      v-if="status === 0 && (index > 0 || discs.length > 1) && !confirm"
                      class="release-status-area__tab-item--accordion">
                      <span @click.prevent="onDeleteDiscClicked">
                      </span>
                    </span>
                  </a>
                </li>
                <li
                  v-if="discs[discs.length - 1].tracks.length > 0 && status === 0 && !confirm"
                  class="release-status-area__tab-item add disabled">
                  <a
                    href="#"
                    @click.prevent="onAddDiscClicked">
                    追加
                    <span class="release-status-area__tab-item--accordion">
                      <span></span>
                    </span>
                  </a>
                </li>
              </ul>
            </div>
            <div
              v-if="status===0 && type==='album'"
              class="multiple-disc-line">
            </div>
            <div
              v-for="(track, index) in currentDiscTracks"
              :key="`disc${currentDiscIndex}-track${index}`"
              class="release-status-area__item u-text-align-left">
              <a :name="`disc${currentDiscIndex}-track${index}`"></a>
              <alert-view
                v-if="confirm && hasConfirmationTrackErrors(index)"
                :errors="confirmTrackErrors[currentDiscIndex][index]" />
              <div class="release-status-area__item-heading">
                <div
                  class="release-status-area__item-num">
                  {{ index + 1 }}
                </div>
                <div class="release-status-area__item-title">
                  {{ track.title_ja || track.title_en }}
                  <span
                    v-if="track.featuring_artists.length > 0"
                    class="release-status-area__item-paragraph">
                    {{ getFeaturingPrefixName(track.featuring_artists[0].prefix) }}
                  </span>
                  <span
                    v-for="(featuring_artist, fIndex) in track.featuring_artists"
                    :key="fIndex">
                    <span v-if="fIndex >= 1">,</span>
                    {{ featuring_artist.name_ja }}
                  </span>
                  <span v-if="track.version_ja">（{{ track.version_ja }}）</span>
                </div>
                <div
                  v-if="status===0 && !confirm"
                  class="release-status-area__item-change">
                  <div
                    v-if="index > 0"
                    class="release-status-area__item-change-up"
                    @click.prevent="onSortUpClicked(index)"></div>
                  <div
                    v-if="currentDiscTracks.length - 1 > index"
                    class="release-status-area__item-change-down"
                    @click.prevent="onSortDownClicked(index)"></div>
                </div>
              </div>
              <div class="release-status-area__item-body">
                <p class="release-status-area__item-paragraph">
                  {{ track.title_kana }}<br>
                  {{ track.title_en }}
                </p>
                <ul
                  v-if="track.main_artists.length > 0"
                  class="release-status-area__artists">
                  <li
                    v-for="(artist, i) in track.main_artists"
                    :key="i">
                    {{ artist.name_ja }} /
                    {{ artist.name_kana }} /
                    {{ artist.name_en }}
                  </li>
                </ul>
                <p
                  v-if="track.featuring_artists.length > 0"
                  class="release-status-area__item-paragraph">
                  Featuring
                  <span
                    v-for="(featuring_artist, i) in track.featuring_artists"
                    :key="featuring_artist.id">
                    {{ featuring_artist.name_ja }} /
                    {{ featuring_artist.name_kana }} /
                    {{ featuring_artist.name_en }}
                    <span v-if="i !== track.featuring_artists.length - 1">,</span>
                  </span>
                </p>
                <p class="release-status-area__item-paragraph">
                  <span v-if="track.classification > 0">
                    楽曲区分：{{ getTrackClassificationName(track.classification) }}<br>
                  </span>
                  <span v-if="track.version_ja">
                    バージョン：{{ track.version_ja }} /
                  </span>
                  ボーカル入り：{{ track.vocal | boolToStr }} /
                  <span v-if="track.vocal">
                    歌詞・タイトルの表現について：{{ track.parental_warning === 'no-explicit' ? 'いいえ' : 'はい' }} /
                  </span>
                  <span v-if="track.vocal">
                    歌唱言語：{{ getLanguageName(track.language) }} /
                  </span>
                  著作権管理団体：{{ getCopyrightGroupName(track.copyright_group) }} /
                  <span
                    v-if="track.copyright_artists.length > 0">著作者：
                  </span>
                  <span
                    v-for="artist in track.copyright_artists"
                    :key="artist.id">
                    {{ artist.name_ja }}
                    ({{ getCopyrightRoleName(artist.roles) }})
                  </span>
                  <span v-if="track.copyright_artists.length > 0"> /</span>
                  <template v-if="getCategoryRoleAssignments(track, 'performance')">
                    パフォーマンスの役割：{{ getCategoryRoleAssignments(track, 'performance') }} /
                  </template>
                  <template v-if="getCategoryRoleAssignments(track, 'production')">
                    プロダクション＆エンジニアリングの役割：{{ getCategoryRoleAssignments(track, 'production') }} /
                  </template>
                  <span v-if="track.copyright_c_copyright">
                    著作権表記(C): {{ track.copyright_c_copyright }}
                    ({{ track.copyright_c_year }}年) /
                  </span>
                  <span v-if="track.copyright_p_copyright">
                    原盤権表記(P): {{ track.copyright_p_copyright }}
                    ({{ track.copyright_p_year }}年) /
                  </span>
                  <span v-if="track.isrc">
                    ISRC：{{ track.isrc }} /
                  </span>
                  試聴開始位置：{{ track.trial_start_min }}分{{ track.trial_start_sec }}秒
                  <span v-if="track.classification > 0">
                    / 楽曲区分 : {{ getTrackClassificationName(track.classification) }}
                  </span>
                  <span v-if="getTrackYoutubeContentId(track)">
                    / YouTubeマネタイズサービス : {{ getTrackYoutubeContentId(track) }}
                  </span>
                  <span v-if="track.rights_documents && track.rights_documents.length > 0">
                    / 許諾書類あり {{ getRightsFileNames(track.rights_documents) }}
                  </span>
                </p>
                <div
                  v-if="appName === 'PNDR' && status >= 1"
                  class="release-status-area__item-paragraph">
                  <span>料率</span>
                  <ul
                    v-if="discTrackRates[currentDiscIndex]
                      && discTrackRates[currentDiscIndex][index]
                      && discTrackRates[currentDiscIndex][index][0]">
                    <li
                      v-for="(data, companyName) in discTrackRates[currentDiscIndex][index][0]"
                      :key="companyName">
                      ・{{ companyName }} : {{ data.rate }} %
                    </li>
                  </ul>
                  <ul
                    v-else>
                    <li
                      v-for="(data, companyName) in productRates"
                      :key="companyName">
                      ・{{ companyName }}: {{ data.rate }} %
                    </li>
                  </ul>
                </div>
                <div
                  v-if="track.filename"
                  class="release-status-area__item-seekbar-wrap">
                  <div
                    style="width: 800px"
                    class="release-status-area__item-seekbar-heading">
                    <svg
                      class="icon-song svg-icon"
                      viewBox="0 0 17.044 23.033">
                      <path
                        class="color1"
                        d="M17.026,21.46a1.362,1.362,0,0,1-.012.509,1.34,1.34,0,
                0,1-1.535,1.038H1.581a1.338,1.338,0,0,1-.259.026,1.352,
                1.352,0,0,1-.328-.041,1.325,1.325,0,0,1-.968-1.54V1.507a1.057,
                1.057,0,0,1,0-.274A1.387,1.387,0,0,1,.553.3,1.377,1.377,0,0,1,
                1.585.011l11.148,0,.146.146c4.047,4.04,4.047,4.04,4.091,4.125a.5.5,
                0,0,1-.815.564C16,4.68,13.84,2.526,12.319,1.007H1.526a.455.455,0,0,
                0-.354.079.4.4,0,0,0-.15.267l0,.154L1.01,21.631a.322.322,0,0,0,
                .392.392l.124-.016,14.105.011a.337.337,0,0,0,.406-.261.349.349,0,0,
                0,0-.144l-.011-.105-.014-14.5H12.526a2.917,2.917,0,0,
                1-2.494-2.421l-.006-3.079a.5.5,0,1,1,1,0v3a1.9,1.9,0,0,0,1.579,
                1.507l4.407-.007Zm-14.5-3.3a2.2,2.2,0,0,1,1.866-1.919,1.907,1.907,0,
                0,1,1.176.088V9.97a.415.415,0,0,1,.289-.391l6.087-2.072a.457.457,0,0,
                1,.4.051.409.409,0,0,1,.184.339v7.464h-.015c0,.035.012.069.012.1a2.2,
                2.2,0,0,1-1.866,1.919,2.394,2.394,0,0,1-.469.049h0A1.754,1.754,0,0,1,
                9.114,17.1a1.256,1.256,0,0,1-.5-1.013,2.2,2.2,0,0,1,1.866-1.919,1.9,
                1.9,0,0,1,1.179.091v-3.7L6.442,12.334v5.1H6.427c0,.036.012.07.012.106a2.2,
                2.2,0,0,1-1.866,1.919,2.394,2.394,0,0,1-.469.049,1.755,1.755,0,0,
                1-1.077-.338A1.254,1.254,0,0,1,2.527,18.157Zm9.129-2.691a.45.45,0,0,
                0-.178-.368.88.88,0,0,0-.531-.151h0a1.53,1.53,0,0,0-1.464,1.137.443.443,
                0,0,0,.178.368,1.032,1.032,0,0,0,.818.123A1.389,1.389,0,0,0,11.656,
                15.466Zm-5.214-5.2v1.19l5.217-1.777V8.486ZM3.4,18.157a.441.441,0,0,0,
                .178.367,1.028,1.028,0,0,0,.818.123,1.386,1.386,0,0,0,1.177-1.108.446.446,
                0,0,0-.178-.367.874.874,0,0,0-.531-.152h0a1.378,1.378,0,0,0-.287.03A1.385,
                1.385,0,0,0,3.4,18.157Z" />
                    </svg>{{ track.filename }}
                    <a
                      v-if="status===0"
                      href="#"
                      class="release-status-area__item-seekbar-change-btn"
                      @click.prevent="onUploadClicked(index)">変更</a>
                  </div>
                  <p
                    v-if="track.bit_length"
                    class="release-status-area__item-audio-attributes">
                    <span>
                      サンプルサイズ：{{ track.bit_length }} ビット /
                      サンプルレート：{{ formatHz(track.sample_rate) }} /
                      曲の長さ：{{ track.duration }}
                    </span>
                  </p>
                  <div
                    class="release-status-area__item-seekbar">
                    <audio-player
                      :url="track.audio_file_url"
                      :current-play-url="currentPlayAudioUrl"
                      :duration-string="track.duration"
                      @play-start="onPlayStart" />
                  </div>
                </div>
                <div
                  v-else
                  class="release-status-area__item-btn-wrap">
                  <a
                    v-if="!uploadFiles.length"
                    class="c-btn c-btn--with-icon"
                    :class="{
                      'upload-button-album' : type === 'album',
                      'upload-button-single' : type === 'single',
                    }"
                    href="#"
                    @click.prevent="onUploadClicked(index)">
                    <svg
                      class="icon-song svg-icon"
                      viewBox="0 0 17.044 23.033">
                      <path
                        d="M17.026,21.46a1.362,1.362,0,0,1-.012.509,1.34,1.34,0,
                0,1-1.535,1.038H1.581a1.338,1.338,0,0,1-.259.026,1.352,
                1.352,0,0,1-.328-.041,1.325,1.325,0,0,1-.968-1.54V1.507a1.057,
                1.057,0,0,1,0-.274A1.387,1.387,0,0,1,.553.3,1.377,1.377,0,0,1,
                1.585.011l11.148,0,.146.146c4.047,4.04,4.047,4.04,4.091,4.125a.5.5,
                0,0,1-.815.564C16,4.68,13.84,2.526,12.319,1.007H1.526a.455.455,0,0,
                0-.354.079.4.4,0,0,0-.15.267l0,.154L1.01,21.631a.322.322,0,0,0,
                .392.392l.124-.016,14.105.011a.337.337,0,0,0,.406-.261.349.349,0,0,
                0,0-.144l-.011-.105-.014-14.5H12.526a2.917,2.917,0,0,
                1-2.494-2.421l-.006-3.079a.5.5,0,1,1,1,0v3a1.9,1.9,0,0,0,1.579,
                1.507l4.407-.007Zm-14.5-3.3a2.2,2.2,0,0,1,1.866-1.919,1.907,1.907,0,
                0,1,1.176.088V9.97a.415.415,0,0,1,.289-.391l6.087-2.072a.457.457,0,0,
                1,.4.051.409.409,0,0,1,.184.339v7.464h-.015c0,.035.012.069.012.1a2.2,
                2.2,0,0,1-1.866,1.919,2.394,2.394,0,0,1-.469.049h0A1.754,1.754,0,0,1,
                9.114,17.1a1.256,1.256,0,0,1-.5-1.013,2.2,2.2,0,0,1,1.866-1.919,1.9,
                1.9,0,0,1,1.179.091v-3.7L6.442,12.334v5.1H6.427c0,.036.012.07.012.106a2.2,
                2.2,0,0,1-1.866,1.919,2.394,2.394,0,0,1-.469.049,1.755,1.755,0,0,
                1-1.077-.338A1.254,1.254,0,0,1,2.527,18.157Zm9.129-2.691a.45.45,0,0,
                0-.178-.368.88.88,0,0,0-.531-.151h0a1.53,1.53,0,0,0-1.464,1.137.443.443,
                0,0,0,.178.368,1.032,1.032,0,0,0,.818.123A1.389,1.389,0,0,0,11.656,
                15.466Zm-5.214-5.2v1.19l5.217-1.777V8.486ZM3.4,18.157a.441.441,0,0,0,
                .178.367,1.028,1.028,0,0,0,.818.123,1.386,1.386,0,0,0,1.177-1.108.446.446,
                0,0,0-.178-.367.874.874,0,0,0-.531-.152h0a1.378,1.378,0,0,0-.287.03A1.385,
                1.385,0,0,0,3.4,18.157Z" />
                    </svg>
                    楽曲ファイルをアップロード
                    <span class="c-btn__icon-arrow"></span>
                  </a>
                </div>
                <p
                  v-for="(error, eIndex) in errors[`${currentDiscIndex}-${index}`]"
                  :key="`${currentDiscIndex}-${index}-${eIndex}`"
                  class="error-text">
                  {{ error }}
                </p>
                <div
                  style="flex-wrap: wrap;"
                  class="release-status-area__item-direction-btn-wrap">
                  <div
                    v-if="status===0"
                    class="release-status-area__item-edit-btn c-btn-release
                    c-btn-release--edit edit-button"
                    :class="{
                      'edit-button-album' : type === 'album',
                      'edit-button-single' : type === 'single',
                    }"
                    @click.prevent="onEditTrackClicked(index)">
                    楽曲情報の編集
                  </div>
                  <div
                    v-if="status===0&&!confirm"
                    class="release-status-area__item-edit-btn c-btn-release
                     c-btn-release--lyrics lyric-button"
                    :class="{ 'lyric-button-disabled': !track.filename }"
                    @click.prevent="onRegisterLyricsClicked(index, track.vocal)">
                    歌詞入力
                  </div>
                  <div
                    v-if="status===0&&type!=='single'&&!confirm"
                    class="release-status-area__item-delete-btn
                    c-btn-release c-btn-release--delete delete-button"
                    @click.prevent="onDeleteTrackClicked(index)">
                    楽曲情報の削除
                  </div>
                </div>
                <div
                  v-if="track.lyrics_type > 0 && !(status===0 && !confirm)"
                  class="c-btn-wrap lyrics-view-entry">
                  <a
                    href="#"
                    class="c-btn c-btn--small"
                    @click.prevent="onViewLyricsClicked(index)">
                    歌詞を見る
                  </a>
                </div>
                <div
                  v-if="!track.vocal"
                  class="release-notice-lyrics-disabled">
                  インストゥルメンタルは歌詞入力できません
                </div>
                <div
                  v-else-if="!(!track.title_kana
                    || track.copyright_artists.length === 0
                    || !track.copyright_artists[0].name_ja) && track.vocal"
                  class="release-notice-lyrics-disabled">
                  歌詞はリリース申請後に登録・修正できません
                </div>

                <div
                  v-if="hasLyricsError(index)"
                  class="track-error">
                  歌詞同期{{ getLyricsCompletePercentage(index) }}%設定済み
                  <br />
                  <a
                    :href="lyricsFaqLink"
                    target="_blank"
                    class="track-faq">
                    歌詞同期を100%にするには？
                  </a>
                </div>
                <div
                  v-if="hasShortDurationError(index)"
                  class="track-error">
                  楽曲の長さが61秒未満です。配信申請には61秒以上の楽曲が必要です。
                </div>
              </div>
            </div>
          </div>
          <div v-if="status === 0 && !confirm">
            <!-- デフォルト -->
            <div
              v-if="uploadFiles.length === 0 && !dragOver && enableAddTracks"
              style="margin-top:30px;"
              class="release-song-add-area__upload-box">
              <div
                v-if="!trackRegisterDisabled"
                class="release-song-add-area__upload-text"
                style="text-align: center">
                <span class="release-song-add-area__upload-text--bold pc">
                  アップロードする楽曲ファイルをドロップ
                </span>
                <span class="release-song-add-area__upload-text--bold sp">
                  アップロードする楽曲ファイルを<br>下記より登録してください
                </span>
                <br class="pc">&nbsp;&nbsp;<span class="pc">または</span>
              </div>
              <a
                href="#"
                :class="[{ 'c-btn--off': trackRegisterDisabled },'c-btn']"
                @click.prevent="onMultiUploadClicked()">
                楽曲ファイルを選択
                <span class="c-btn__icon-arrow"></span>
              </a>
            </div>
            <!-- ファイルがドラッグされた時 -->
            <div
              v-if="dragOver && !uploadFiles.length && !trackRegisterDisabled && !confirm"
              style="margin-top:30px;"
              class="release-song-add-area__upload-box release-song-add-area__upload-box--on"
              @keydown.esc="onFileDragleave"
              @drop.prevent="onFileDrop">
              <div
                class="release-song-add-area__upload-text"
                style="text-align: center">
                <span class="release-song-add-area__upload-text--bold">
                  ここにファイルをドロップ
                </span>
              </div>
            </div>
            <!-- ファイルがドロップ＆アップロードされた時 -->
            <div
              v-if="uploadFiles.length && !hideDropZone"
              style="margin-top:30px;height: auto;"
              class="release-song-add-area__upload-box release-song-add-area__upload-box--on">
              <div class="release-song-add-area__upload-text">
                {{ type === 'album' ? 'これらの' : 'この' }}ファイルをアップロードします。<br>
                楽曲情報を後から入力してください。<br>
                <span
                  v-for="(inUploadFile, index) in uploadFiles"
                  :key="index"
                  class="release-song-add-area__upload-text--bold">
                  <span class="upload-file-word-break">
                    {{ inUploadFile.name }}<br>
                  </span>
                </span>
              </div>
              <div class="release-upload-btn-wrap">
                <a
                  style="margin-right: 20px"
                  class="c-btn c-btn--back"
                  href="#"
                  @click.prevent="onUploadCancelClicked">
                  <span>キャンセル</span>
                </a>
                <a
                  class="c-btn"
                  href="#"
                  @click.prevent="onUploadFilesClicked">
                  <span>アップロード</span>
                </a>
              </div>
            </div>
          </div>

          <div
            v-if="status===0"
            class="track-error">
            <div
              v-for="(trackError, index) in trackErrors"
              :key="index">
              {{ trackError }}
            </div>
          </div>
          <div
            v-if="errors.status"
            class="track-error">
            {{ errors.status }}
          </div>

          <div
            v-if="status===0 && enableAddTracks && !confirm"
            class="c-btn-wrap">
            <a
              :class="[{ 'c-btn--off': trackRegisterDisabled },'c-btn']"
              @click.prevent="onAddTrackClicked()">
              {{ currentDiscTracks.length + 1 }}曲目を登録する
              <span
                class="c-btn__icon-arrow">
              </span>
            </a>
          </div>
        </div>
      </div>
      <div class="release-info-area">
        <div
          v-if="status === 0 && !confirm"
          class="c-gray-box__title">
          ジャケット画像、リリース情報の登録状況は、<br class="sp">以下でご確認いただけます。
        </div>
        <div
          v-if="Object.keys(confirmProductErrors).length">
          <alert-view
            :errors="confirmProductErrors" />
        </div>
        <div
          v-if="status !== 0"
          class="relese-info-caption">
          <div class="relese-info-jaket c-gray-box__caption">
            <svg
              class="icon-add_jacket svg-icon"
              viewBox="0 0 26.5 24.994">
              <path
                class="color1"
                d="M14.436,0h-.012L1.458,2A1.5,1.5,0,0,0,0,3.494v18a1.479,1.479,0,
                0,0,1.414,1.494h.01L14.5,24.994a1.5,1.5,0,0,0,1.5-1.5v-22A1.51,1.51,
                0,0,0,14.436,0ZM15,23.494a.5.5,0,0,1-.424.506L1.5,21.994a.5.5,0,0,
                1-.5-.5v-18a.5.5,0,0,1,.5-.5l13-2a.5.5,0,0,1,
                .5.5Zm11.5-21v20h-10v-1h9v-18h-9v-1h10ZM16.5,20a7.571,7.571,0,0,0,
                0-15.009L16.629,4a8.571,8.571,0,0,1,0,16.991Zm1.417-6.978A1.63,
                1.63,0,0,0,16.9,10.953a.5.5,0,1,1,.323-.946,2.629,2.629,0,0,1,
                .017,4.97.5.5,0,0,1-.33-.944A1.623,1.623,0,0,0,17.913,13.021Z" />
            </svg>
            ジャケット画像
          </div>
          <div class="relese-info-product c-gray-box__caption">
            <svg
              class="icon-add_product svg-icon"
              viewBox="0 0 17.044 23.033">
              <path
                class="color1"
                d="M1.322,23.033a1.352,1.352,0,0,1-.328-.041,1.325,1.325,0,0,
                1-.968-1.54V1.507a1.057,1.057,0,0,1,0-.274A1.4,1.4,0,0,1,
                1.585.011l11.148,0,.146.146c4.042,4.036,4.042,4.036,4.084,4.112a.5.5,0,
                0,1-.807.579c-.188-.193-3.141-3.142-3.837-3.837H1.526a.453.453,0,0,
                0-.354.079.4.4,0,0,0-.15.267l0,.154L1.01,21.631a.322.322,0,0,0,
                .392.392l.124-.016,14.105.011a.338.338,0,0,0,.406-.261.349.349,
                0,0,0,0-.144l-.011-.105-.014-14.5H12.526a2.917,2.917,0,0,
                1-2.494-2.421l-.006-3.079a.5.5,0,1,1,1,0v3a1.9,1.9,0,0,0,1.579,
                1.507l4.407-.007.014,15.453a1.362,1.362,0,0,1-.012.509,1.341,
                1.341,0,0,1-1.535,1.038H1.581A1.338,1.338,0,0,1,
                1.322,23.033Zm2.2-12.526h10v-1h-10Zm0,3h10v-1h-10Zm0,3h6v-1h-6Z" />
            </svg>
            リリース情報
          </div>
        </div>
        <div class="release-info-area__wrap">
          <div class="release-info-area__pic release-info-area__pic--none">
            <img
              class="preview-image"
              :src="jacketImage" />
            <div
              v-if="status===0 && hasJacket"
              class="release-info-area__pic-edit-btn"
              @click.prevent="onAddJacketClicked">
            </div>
          </div>
          <div
            v-if="status === 1"
            class="relese-info-product-sp c-gray-box__caption">
            <svg
              class="icon-add_product svg-icon"
              viewBox="0 0 17.044 23.033">
              <path
                class="color1"
                d="M1.322,23.033a1.352,1.352,0,0,1-.328-.041,1.325,1.325,0,0,
                1-.968-1.54V1.507a1.057,1.057,0,0,1,0-.274A1.4,1.4,0,0,1,
                1.585.011l11.148,0,.146.146c4.042,4.036,4.042,4.036,4.084,4.112a.5.5,0,
                0,1-.807.579c-.188-.193-3.141-3.142-3.837-3.837H1.526a.453.453,0,0,
                0-.354.079.4.4,0,0,0-.15.267l0,.154L1.01,21.631a.322.322,0,0,0,
                .392.392l.124-.016,14.105.011a.338.338,0,0,0,.406-.261.349.349,
                0,0,0,0-.144l-.011-.105-.014-14.5H12.526a2.917,2.917,0,0,
                1-2.494-2.421l-.006-3.079a.5.5,0,1,1,1,0v3a1.9,1.9,0,0,0,1.579,
                1.507l4.407-.007.014,15.453a1.362,1.362,0,0,1-.012.509,1.341,
                1.341,0,0,1-1.535,1.038H1.581A1.338,1.338,0,0,1,
                1.322,23.033Zm2.2-12.526h10v-1h-10Zm0,3h10v-1h-10Zm0,3h6v-1h-6Z" />
            </svg>
            リリース情報
          </div>
          <div class="release-info-area__list">
            <dl
              v-if="releaseId&&isBtoC"
              class="release-info-area__list-node">
              <dt class="release-info-area__list-title">リリースID</dt>
              <dd class="release-info-area__list-text release-info-area__list-text--notset">
                <span>
                  <div>
                    {{ releaseId }}
                  </div>
                </span>
              </dd>
            </dl>
            <dl class="release-info-area__list-node">
              <dt class="release-info-area__list-title">メインアーティスト名</dt>
              <dd class="release-info-area__list-text release-info-area__list-text--notset">
                <span v-if="type === 'single' && artistType === 1">
                  <div
                    v-for="(track, trackIndex) in currentDiscTracks"
                    :key="trackIndex">
                    <div
                      v-for="(main_artist,idx) in track.main_artists"
                      :key="idx">
                      {{ main_artist.name_ja }}
                    </div>
                  </div>
                </span>
                <span v-else-if="artists.length">
                  <div
                    v-for="artist in artists"
                    :key="artist.id">
                    {{ artist.name }}
                  </div>
                </span>
                <span v-else>
                  未設定
                </span>
              </dd>
            </dl>
            <dl class="release-info-area__list-node">
              <dt class="release-info-area__list-title">商品タイトル名</dt>
              <dd class="release-info-area__list-text release-info-area__list-text--notset">
                {{ product.title_ja || product.title_en || '未設定' }}
                {{ type === 'single'?getFeaturingArtistsNames(currentDiscTracks[0]):'' }}
                {{ product.version_ja ? `（${product.version_ja}）` : '' }}
              </dd>
            </dl>
            <dl class="release-info-area__list-node">
              <dt class="release-info-area__list-title">商品タイトル名（カナ表記）</dt>
              <dd class="release-info-area__list-text release-info-area__list-text--notset">
                {{ product.title_kana || '未設定' }}{{ product.version_kana || '' }}
              </dd>
            </dl>
            <dl class="release-info-area__list-node">
              <dt class="release-info-area__list-title">商品タイトル名（アルファベット表記）</dt>
              <dd class="release-info-area__list-text release-info-area__list-text--notset">
                {{ product.title_en || '未設定' }}
                {{ product.version_en ? `(${product.version_en})` : '' }}
              </dd>
            </dl>
            <dl class="release-info-area__list-node">
              <dt class="release-info-area__list-title">ジャンル</dt>
              <dd class="release-info-area__list-text release-info-area__list-text--notset">
                {{ genres[product.genre1] || '未設定' }}
              </dd>
            </dl>
            <dl class="release-info-area__list-node">
              <dt class="release-info-area__list-title">サブジャンル</dt>
              <dd class="release-info-area__list-text release-info-area__list-text--notset">
                {{ genres[product.genre2] || '未設定' }}
              </dd>
            </dl>
            <dl class="release-info-area__list-node">
              <dt class="release-info-area__list-title">レーベル</dt>
              <dd class="release-info-area__list-text release-info-area__list-text--notset">
                {{ product.label_name_ja || '未設定' }}
              </dd>
            </dl>
            <dl
              v-if="!product.is_cmap_jan"
              class="release-info-area__list-node">
              <dt class="release-info-area__list-title">JANコード</dt>
              <dd class="release-info-area__list-text release-info-area__list-text--notset">
                {{ product.jan || '未設定' }}
              </dd>
            </dl>
            <dl class="release-info-area__list-node">
              <dt class="release-info-area__list-title">発売実績</dt>
              <dd class="release-info-area__list-text release-info-area__list-text--notset">
                {{ product.released | toReleasedType }}
              </dd>
            </dl>
            <dl
              v-if="product.released"
              class="release-info-area__list-node">
              <dt class="release-info-area__list-title">発売日</dt>
              <dd class="release-info-area__list-text release-info-area__list-text--notset">
                {{ product.original_release_date | formatDate }}
              </dd>
            </dl>
            <dl
              v-if="isBtoB"
              class="release-info-area__list-node">
              <dt class="release-info-area__list-title">著作権表記(C) / 年号</dt>
              <dd class="release-info-area__list-text release-info-area__list-text--notset">
                {{ product.copyright_c_copyright || '未設定' }} /
                {{ product.copyright_c_year }}
              </dd>
            </dl>
            <dl
              v-if="isBtoB"
              class="release-info-area__list-node">
              <dt class="release-info-area__list-title">原盤権表記(P) / 年号</dt>
              <dd class="release-info-area__list-text release-info-area__list-text--notset">
                {{ product.copyright_p_copyright || '未設定' }} /
                {{ product.copyright_p_year }}
              </dd>
            </dl>
            <dl
              v-if="appName === 'PNDR' && status >= 1"
              class="release-info-area__list-node">
              <dt class="release-info-area__list-title">料率</dt>
              <dd class="release-info-area__list-text release-info-area__list-text--notset">
                <ul>
                  <li
                    v-for="(data, companyName) in productRates"
                    :key="companyName">
                    ・{{ companyName }}: {{ data.rate }} %
                  </li>
                </ul>
              </dd>
            </dl>
          </div>
          <div
            v-if="status===0 && hasProduct"
            class="release-info-area__edit">
            <div
              class="release-info-area__edit-btn"
              @click.prevent="onAddProductClicked">
              <svg
                class="icon-edit svg-icon"
                viewBox="0 0 26 26">
                <path
                  class="color1"
                  d="M3,22l5.75-1.11L22,7.64,17.35,3,4.11,16.25ZM18.69,5.76l-5,5,.7.71,5-5,1.18,
                  1.18L9.11,19.1,5.9,15.88,17.35,4.42ZM5,16.74l.16-.15,3.22,3.22L8.25,20l-4,
                  .78ZM25,4.4,20.61,0,18,2.61,22.39,7ZM19.42,2.61l1.19-1.19,3,3L22.39,5.59Zm1.69,
                  9.64H22V22.8a2.2,2.2,0,0,1-2.2,2.2H2.2A2.2,2.2,0,0,1,0,22.8V5.22A2.2,2.2,0,0,1,
                  2.2,3H12.75V3.9H2.2A1.32,1.32,0,0,0,.88,5.22V22.8A1.32,1.32,0,0,0,2.2,
                  24.12H19.79a1.32,1.32,0,0,0,1.32-1.32Z" />
              </svg>
              編集
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="status===0 && unevenBitDepth"
      class="bit-depth-error">
      アルバム内の楽曲ファイルは全て同じサンプルサイズ（24bitもしくは16bit）での登録が必要です。
    </div>

    <p
      v-if="subscriptionDefaulted"
      class="pcmt20 spmt20 u-text-align-center">
      サブスクプランのお支払いの確認ができておりませんので楽曲の登録ができない状態です。<br>
      決済情報の更新をお願いいたします。<br>
      <router-link
        :to="{name: 'settlement-method-change'}"
        class="c-text-link">
        決済情報を更新する
      </router-link>
    </p>
    <div
      v-if="hasLyricsError()"
      class="track-error">
      歌詞登録が未完了です
      <br />
      <a
        :href="lyricsFaqLink"
        target="_blank"
        class="track-error">
        歌詞同期を100%にするには？
      </a>
    </div>
    <div
      v-if="errors['releasable']"
      class="track-error">
      {{ errors['releasable'][0] }}
      <br />
    </div>
    <div
      v-if="status===0 && !confirm"
      class="c-btn-wrap">
      <a
        class="c-btn"
        :class="{ 'c-btn--off': nextButtonDisabled() }"
        href="#"
        @click.prevent="
          subscriptionCarrierFeePending ?
            subscriptionCarrierFeePendingDialogShown=true : onNextClickedHandle()
        ">
        <span>ストア選択へ</span>
        <span class="c-btn__icon-arrow"></span>
      </a>
    </div>

    <div
      v-if="dragOver"
      class="drop-zone"
      @dragleave.prevent="onFileDragleave">
    </div>

    <confirm-dialog
      name="validateTracks"
      :is-shown="validateTracksDialogShown"
      :default-button-title="false"
      cancel-button-title="閉じる"
      title="楽曲ファイルのエラー"
      @closed="validateTracksDialogShown = false"
      @default-clicked="validateTracksDialogShown = false"
      @cancel-clicked="validateTracksDialogShown = false">
      <template #body>
        <span class="release-song-add-area__upload-text--bold">
          <div class="form--error">
            <div
              v-for="(error, index) in multiUploadErrors"
              :key="index">
              <b>[{{ error.name }}]</b>
              <div
                v-for="(message, mIndex) in error.messages"
                :key="`m-${mIndex}`"
                class="error-text"
                style="white-space: pre">{{ message }}</div>
            </div>
          </div>
        </span>
      </template>
    </confirm-dialog>

    <confirm-dialog
      name="deleteDisc"
      :is-shown="deleteDiscDialogShown"
      title="ディスクの削除"
      @closed="deleteDiscDialogShown = false"
      @default-clicked="onDeleteDiscDialogOk"
      @cancel-clicked="deleteDiscDialogShown = false">
      <template #body>
        ディスク内の楽曲も削除されます。<br />
        よろしいですか？
      </template>
    </confirm-dialog>
    <input
      ref="file"
      type="file"
      style="display:none"
      @change="onFileChanged" />
    <input
      ref="multiFile"
      type="file"
      multiple="multiple"
      style="display:none"
      @change="onMultiFileChanged" />

    <confirm-dialog
      style="width:900px;"
      name="changeVariousArtists"
      :is-shown="changeVariousArtistsDialogShown"
      default-button-title="変更する"
      cancel-button-title="キャンセル"
      title="アルバムのメインアーティストを変更しますか？"
      @closed="changeVariousArtistsDialogShown = false"
      @default-clicked="onChangeVariousArtistsDialog"
      @cancel-clicked="changeVariousArtistsDialogShown = false">
      <template #body>
        <div class="release-change-various-artists-dialog">
          <span class="">現在: {{ Array.from(uniqueMainArtists).join(',') }}</span><br />
          <span>変更:Various Artists</span><br /><br />
          楽曲のメインアーティストが5組以上参加している場合は<br />
          {{ type === 'album' ? 'アルバム' : 'シングル' }}のメインアーティストを
          「 Various Artists 」に変更が必要です。<br /><br />
          ※「変更する」を選択した場合、元に戻すことはできません。
          ストア選択画面に遷移しますので、配信ストアの選択をしてください。<br />
          ※ 「 Various Artists 」に変更しない場合は、楽曲のメインアーティストが
          4組以下になるよう、メインアーティストを修正してください。
        </div>
      </template>
    </confirm-dialog>

    <confirm-dialog
      name="subscriptionCarrierFeePending"
      :is-shown="subscriptionCarrierFeePendingDialogShown"
      :default-button-title="'決済情報を更新する'"
      :cancel-button-title="false"
      title="ストア選択に進むことができません。"
      @closed="subscriptionCarrierFeePendingDialogShown = false"
      @default-clicked="onSubscriptionCarrierFeePendingClicked">
      <template #body>
        ストア選択に進むには<br>決済情報を更新する必要があります。
      </template>
    </confirm-dialog>

    <lyrics-view-modal
      :is-shown="lyricsViewModalShown"
      :discs="discs"
      :product-id="product.id"
      :product-title="product.title_ja || product.title_en"
      :initial-disc-index="lyricsViewModalDiscIndex"
      :initial-track-index="lyricsViewModalTrackIndex"
      @closed="lyricsViewModalShown = false" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ReleaseStepArea from '../StepArea'
import ConfirmDialog from '../../../../components/ConfirmDialog'
import AudioPlayer from '../../AudioPlayer'
import AlertView from '../../AlertView'
import LyricsViewModal from '../Lyrics/ViewModal'

export default {
  name: 'ReleaseInformation',
  components: {
    AlertView,
    ConfirmDialog,
    ReleaseStepArea,
    AudioPlayer,
    LyricsViewModal,
  },
  filters: {
    join(array, separator) {
      return array.join(separator)
    },
    boolToStr(value) {
      return value ? 'YES' : 'NO'
    },
    toReleasedType: (value) => (parseInt(value, 10) === 1 ? 'あり' : 'なし'),
  },
  props: {
    confirm: {
      type: Boolean,
      default: false,
    },
    confirmProductErrors: {
      type: Object,
      default: () => {},
    },
    confirmTrackErrors: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      status: 2,
      artistType: 1,
      jacketImage: null,
      product: {},
      artists: [],
      mainArtists: [],
      currentDiscIndex: 0,
      discs: [
        { tracks: [] },
      ],
      tracks: [],
      uploadTargetIndex: null,
      errors: {},
      multiUploadErrors: [],
      languages: {},
      copyrightGroups: {},
      featuringPrefixes: {},
      performanceRoleLabels: {},
      productionRoleLabels: {},
      type: '',
      deleteDiscDialogShown: false,
      hasLyricsErrors: [],
      lyricsCompletePercentages: [],
      currentPlayAudioUrl: '',
      dragOver: false,
      uploadFiles: [],
      isMultiple: false,
      hideDropZone: false,
      validateTracksDialogShown: false,
      genres: {},
      hasUploadError: false,
      alreadyAgreed: false,
      uniqueMainArtists: new Set(),
      isSatisfyMainArtists: true,
      changeVariousArtistsDialogShown: false,
      vocaloidList: [],
      subscriptionCarrierFeePendingDialogShown: false,
      releasable: true,
      productRates: [],
      discTrackRates: [],
      releaseStatus: 0,
      lyricsViewModalShown: false,
      lyricsViewModalDiscIndex: 0,
      lyricsViewModalTrackIndex: 0,
    }
  },
  computed: {
    ...mapGetters('auth', ['subscriptionDefaulted', 'subscriptionCarrierFeePending']),
    isAppendDspRequest() {
      return [5, 6].includes(this.releaseStatus)
    },
    hasJacket() {
      if (this.$store.state.auth.permission === 10) {
        // 上級管理者ならばジャケット画像は未登録でもOK
        return true
      }
      return (this.jacketImage && this.jacketImage.length)
    },
    hasProduct() {
      if (this.$store.state.auth.permission === 10) {
        // 上級管理者ならばリリース情報の登録は未登録でもOK
        return true
      }
      return (this.product && this.product.is_draft < 2)
    },
    hasTracks() {
      const hasTracks = this.discs.filter(disc => disc.tracks.length > 0).length
      return this.product && hasTracks
    },
    unevenBitDepth() {
      if (this.$store.state.auth.permission === 10) {
        return false
      }
      const bitLength = new Set()
      this.discs.forEach(disc => {
        disc.tracks.forEach(track => {
          bitLength.add(track.bit_length)
        })
      })
      if (bitLength.size > 1) {
        return true
      }
      return false
    },
    trackErrors() {
      const errors = []
      if (this.$store.state.auth.permission === 10) {
        // 上級管理者ならばエラーを迂回
        if (!(this.discs.some(disc => disc.tracks.length > 0))) {
          errors.push('楽曲情報が登録されていません。')
        }
        return errors
      }
      // ジャケ写が登録されているかどうか
      if (!this.jacketImage) {
        errors.push('ジャケット画像を登録して下さい。')
      }
      // リリース情報が登録されているかどうか
      if (this.product.is_draft === 2) {
        errors.push('リリース情報を登録して下さい。')
      }
      // 最低曲数
      const typeName = this.type === 'album' ? 'アルバム' : 'シングル'
      const minTrack = this.type === 'album' ? 2 : 1
      const maxTrack = this.type === 'album' ? 99 : 1
      // 楽曲に楽曲ファイルがセットされているかどうか
      this.discs.forEach((disc, discIndex) => {
        let missingTarget = ''
        let missingTrackInfo = ''
        let missingTrackMonetize = ''
        let missingTrackRoles = ''
        disc.tracks.forEach((track, index) => {
          if (!track.filename) {
            missingTarget = `${missingTarget}${(missingTarget.length > 0 ? '、' : '')}${index + 1}曲目`
          }
          if (!track.title_kana
            || track.copyright_artists.length === 0
            || !track.copyright_artists[0].name_ja) {
            missingTrackInfo = `${missingTrackInfo}${(missingTrackInfo.length > 0 ? '、' : '')}${index + 1}曲目`
          }
          if (this.isBtoC && track.role_assignments?.length === 0) {
            missingTrackRoles = `${missingTrackRoles}${(missingTrackRoles.length > 0 ? '、' : '')}${index + 1}曲目`
          }
          // eslint-disable-next-line no-underscore-dangle
          if (track._restrictions) {
            // eslint-disable-next-line no-underscore-dangle
            track._restrictions.forEach(restriction => {
              if ([this.product.genre1, this.product.genre2].some(genre => genre === 'Spoken Word')
               && restriction.settings
               && (restriction.settings.contents_id_enabled ?? 0) === 1) {
                missingTrackMonetize = `${missingTrackMonetize}${(missingTrackMonetize.length > 0 ? '、' : '')}${index + 1}曲目`
              }
            })
          }
        })
        if (this.unevenBitDepth) {
          errors.push('アルバム内の楽曲ファイルは全て同じサンプルサイズ（24bitもしくは16bit）での登録が必要です。')
        }
        if (missingTarget) {
          errors.push(`Disc${discIndex + 1}: ${missingTarget}の楽曲ファイルをアップロードして下さい。`)
        }
        if (missingTrackInfo) {
          errors.push(`Disc${discIndex + 1}: ${missingTrackInfo}の楽曲情報が登録されていません。`)
        }
        if (missingTrackMonetize) {
          errors.push(`Disc${discIndex + 1}: ${missingTrackMonetize}のYouTubeマネタイズサービスはジャンルが Spoken Word のため利用出来ません 。`)
        }
        if (missingTrackRoles) {
          errors.push(`Disc${discIndex + 1}: ${missingTrackRoles}の役割情報が登録されていません。`)
        }
        if (disc.tracks.length < minTrack) {
          errors.push(
            minTrack === 1
              ? `Disc${discIndex + 1}: ${typeName}登録には${minTrack}曲の登録が必要になります。`
              : `Disc${discIndex + 1}: ${typeName}登録には${minTrack}曲以上必要になります。`,
          )
        }
      })
      if (this.totalTracks > maxTrack) {
        errors.push(`${typeName}登録には${maxTrack}曲以上登録できません。`)
      }
      if (!this.isSatisfyMainArtists && this.type === 'album') {
        errors.push('メインアーティストを「Various Artists」に選択している場合、 楽曲のメインアーティストは5組以上登録してください。')
      }

      return errors
    },
    currentDiscTracks() {
      const release = JSON.parse(window.sessionStorage.getItem('album'))
      const { tracks } = this.discs[this.currentDiscIndex]
      if (tracks[this.currentDiscIndex]?.copyright_artists.length === 0) {
        const vocaloid1 = release.vocaloid || []
        vocaloid1.forEach(singleVocaloid => {
          if (!tracks[this.currentDiscIndex].main_artists.filter(singleTrack => singleTrack.name_ja
            === singleVocaloid.name_ja).length > 0) {
            tracks[this.currentDiscIndex].main_artists.push(singleVocaloid)
          }
        })
      }
      return tracks || []
    },
    totalTracks() {
      let total = 0
      this.discs.forEach(disc => {
        total += disc.tracks.length
      })
      return total
    },
    enableAddTracks() {
      return this.type === 'album'
        ? this.totalTracks < 99
        : this.totalTracks < 1
    },
    trackRegisterDisabled() {
      return this.type === 'single' && !this.hasProduct
    },
    lyricsFaqLink() {
      return this.isBtoB ? '/client/faqs/119' : '/client/faqs/118'
    },
    releaseId() {
      if (this.discs.length === 0
        || this.discs[0].tracks.length === 0
        || !this.discs[0].tracks[0].id) {
        return false
      }
      const trackIds = this.discs[0].tracks.map(d => d.id ?? Number.MAX_SAFE_INTEGER)
      return `${this.product.id}-${trackIds.sort()[0]}`
    },
  },
  mounted() {
    // セッションストレージから一時保存されたデータを読み込み
    const release = JSON.parse(window.sessionStorage.getItem('album'))
    if (!release) {
      this.$router.push({ name: 'index' })
      return
    }
    this.hasLyricsErrors = JSON.parse(window.sessionStorage.getItem('hasLyricsError') || '[]')
    this.lyricsCompletePercentages = JSON.parse(window.sessionStorage.getItem('lyricsCompletePercentage') || '[]')
    this.vocaloidList = release.vocaloid || []
    this.alreadyAgreed = release.product.youtube_monetize_agreed
    this.status = release.status
    this.releaseStatus = release.release_status || 0
    // 納品中（テイクダウン）の時は申請出来ないようにする
    if (release.release_status === 14) {
      this.status = -1
    }
    this.artistType = release.artistType
    this.jacketImage = release.jacketImage
    this.product = release.product || {}
    this.discs = release.discs || [{ tracks: [] }]
    this.type = release.type
    this.$emit('stateDetected', { status: this.status, type: this.type })
    this.fetchArtists(release.artists || [])
    this.fetchLanguages()
    this.fetchCopyrightGroups()
    this.fetchGenres()
    this.fetchFeaturingPrefixes()
    this.fetchRoleCatalog()
    // location のハッシュに disc*-track* という文字があればタブを切り替え、指定トラックIDまでスクロールする。
    if (window.location.hash.indexOf('-') > 0) {
      const values = window.location.hash.split('-')
      this.currentDiscIndex = parseInt(values[0].substr(5), 10)
      this.$nextTick(() => {
        window.location.href = `#disc${this.currentDiscIndex}-track${values[1].substr(5)}`
      })
    }
    this.isSatisfyMainArtists = this.validateSatisfyMainArtists()
    if (release.rates && release.rates.productRates) {
      const tmpRatesEntry = Object
        .entries(release.rates.productRates)
        .sort((a, b) => a[1].order - b[1].order)
      this.productRates = Object.fromEntries(tmpRatesEntry)
    }
    if (release.rates && release.rates.discTrackRates) {
      const tmpDiscTrackEntry = Object.entries(release.rates.discTrackRates)
      tmpDiscTrackEntry.forEach((disc) => {
        if (disc && Array.isArray(disc)) {
          disc.forEach((track) => {
            if (track && Array.isArray(track)) {
              track.forEach((trackRate) => {
                // トラックの料率
                if (trackRate[0] && Array.isArray(trackRate[0])) {
                  trackRate[0].sort((a, b) => a[1].order - b[1].order)
                }
                // マネタイズの料率
                // if (trackRate[1] && Array.isArray(trackRate[1])) {
                //   trackRate[1].sort((a, b) => a[1].order - b[1].order)
                // }
              })
            }
          })
        }
      })
      this.discTrackRates = Object.fromEntries(tmpDiscTrackEntry)
    }
  },
  methods: {
    // 歌詞閲覧モーダルを、クリックした楽曲を選択した状態で開く
    onViewLyricsClicked(trackIndex) {
      this.lyricsViewModalDiscIndex = this.currentDiscIndex
      this.lyricsViewModalTrackIndex = trackIndex
      this.lyricsViewModalShown = true
    },
    // ジャンルマスタを取得
    async fetchGenres() {
      const { data } = await window.axios.get('/api/client/genres')
      this.genres = {
        '': '未指定',
        ...data,
      }
    },
    // アーティストマスタの読み込み
    async fetchArtists(ids) {
      const response = await window.axios.get('/api/client/artists/getAllByIds', {
        params: { ids },
      })
      this.artists = []
      const artists = response.data.data
      ids.forEach(id => {
        const res = artists.filter(artist => artist.id === id)
        if (res.length > 0) {
          this.artists.push(res[0])
        }
      })
      this.artists.forEach(item => {
        this.mainArtists.push({
          id: item.id,
          company_id: item.company_id ?? null,
          name_ja: item.name_ja,
          name_kana: item.name_kana,
          name_en: item.name_en,
          type: item.type,
          image_path: item.image_path,
          require_user_artist: item.require_user_artist,
        })
      })
      this.vocaloidList.forEach(item => {
        // eslint-disable-next-line max-len
        if (this.artists.filter(artist => artist.name_ja === item.name_ja).length === 0) this.artists.push(item)
        this.mainArtists.push(item)
      })
    },
    // 言語マスタの読み込み
    async fetchLanguages() {
      const { data } = await window.axios.get('/api/client/code/languages')
      this.languages = data
    },
    // 著作権団体マスタの読み込み
    async fetchCopyrightGroups() {
      const { data } = await window.axios.get('/api/client/code/copyright-groups')
      this.copyrightGroups = data
    },
    // Featuringの接続表記マスタを取得
    async fetchFeaturingPrefixes() {
      const { data } = await window.axios.get('/api/client/code/featuring-prefixes')
      this.featuringPrefixes = data
    },
    // ジャケット画像登録画面への遷移ボタンクリック
    onAddJacketClicked() {
      window.scrollTo(0, 0)
      this.$router.push({ name: `${this.$route.meta.sideMenuId}-step2-jacket` })
    },
    // リリース情報登録画面への遷移ボタンクリック
    onAddProductClicked() {
      window.scrollTo(0, 0)
      this.$router.push({ name: `${this.$route.meta.sideMenuId}-step2-product` })
    },
    // 楽曲登録ボタンクリック
    onAddTrackClicked() {
      this.$router.push({
        name: `${this.$route.meta.sideMenuId}-step2-track`,
        params: {
          discIndex: this.currentDiscIndex,
          trackIndex: this.currentDiscTracks.length,
        },
      })
      window.scrollTo(0, 0)
    },
    // 楽曲編集ボタンクリック
    onEditTrackClicked(index) {
      this.$router.push({
        name: `${this.$route.meta.sideMenuId}-step2-track`,
        params: {
          discIndex: this.currentDiscIndex,
          trackIndex: index,
        },
      })
      window.scrollTo(0, 0)
    },
    onRegisterLyricsClicked(index, vocal) {
      if (!vocal) {
        return
      }
      this.$router.push({
        name: `${this.$route.meta.sideMenuId}-step2-lyrics`,
        params: {
          discIndex: this.currentDiscIndex,
          trackIndex: index,
        },
      })
    },
    // Disc切り替え
    onDiscTabClicked(index) {
      if (this.currentDiscIndex === index) {
        return
      }
      this.currentDiscIndex = this.discs.length >= index + 1 ? index : this.discs.length - 1
      window.location.href = `#disc${this.currentDiscIndex}-track0`
    },
    // Disc追加ボタンクリック
    onAddDiscClicked() {
      const release = JSON.parse(window.sessionStorage.getItem('album'))
      const { discs } = release
      discs.push({
        tracks: [],
      })
      window.sessionStorage.setItem('album', JSON.stringify(release))
      this.currentDiscIndex = discs.length - 1
      this.discs = discs
    },
    // Disc削除ボタンクリック
    onDeleteDiscClicked() {
      if (this.currentDiscTracks.length === 0) {
        this.onDeleteDiscDialogOk()
      } else {
        this.deleteDiscDialogShown = true
      }
    },
    async onDeleteDiscDialogOk() {
      this.deleteDiscDialogShown = false
      const release = JSON.parse(window.sessionStorage.getItem('album'))
      const productId = release.product.id
      await window.axios.delete(`/api/client/products/${productId}/disc/${this.currentDiscIndex}`)

      const { discs } = release
      discs.splice(this.currentDiscIndex, 1)
      window.sessionStorage.setItem('album', JSON.stringify(release))
      this.currentDiscIndex = discs.length - 1
      this.$nextTick(() => {
        this.discs = discs
      })
      window.location.href = `#disc${this.currentDiscIndex}-track0`
    },
    // 楽曲ソート↑クリック
    async onSortUpClicked(index) {
      // 楽曲の入れ替え
      const release = JSON.parse(window.sessionStorage.getItem('album'))
      const productId = release.product.id
      try {
      // サーバ側更新
        await window.axios.post(`/api/client/products/${productId}/disc/${this.currentDiscIndex}/track/${index}/up`)
        // フロント側更新
        this.currentDiscTracks[index].track_index = index - 1
        this.currentDiscTracks[index - 1].track_index = index
        this.currentDiscTracks.splice(
          index - 1,
          2,
          this.currentDiscTracks[index],
          this.currentDiscTracks[index - 1],
        )
        release.discs[this.currentDiscIndex].tracks = this.currentDiscTracks
        window.sessionStorage.setItem('album', JSON.stringify(release))
        // エラーメッセージの入れ替え
        const upperError = this.errors[index - 1] || null
        this.errors[`${this.currentDiscIndex}-${index - 1}`] = this.errors[`${this.currentDiscIndex}-${index}`]
        this.errors[`${this.currentDiscIndex}-${index}`] = upperError

        const upperLyricsError = this.hasLyricsErrors[`${this.currentDiscIndex}-${index - 1}`]
        this.hasLyricsErrors[`${this.currentDiscIndex}-${index - 1}`] = this.hasLyricsErrors[`${this.currentDiscIndex}-${index}`]
        this.hasLyricsErrors[`${this.currentDiscIndex}-${index}`] = upperLyricsError
        window.sessionStorage.setItem('hasLyricsError', JSON.stringify(this.hasLyricsErrors))

        const upperLyricsCompletePercentage = this.lyricsCompletePercentages[`${this.currentDiscIndex}-${index - 1}`]
        this.lyricsCompletePercentages[`${this.currentDiscIndex}-${index - 1}`] = this.lyricsCompletePercentages[`${this.currentDiscIndex}-${index}`]
        this.lyricsCompletePercentages[`${this.currentDiscIndex}-${index}`] = upperLyricsCompletePercentage
        window.sessionStorage.setItem('lyricsCompletePercentage', JSON.stringify(this.lyricsCompletePercentages))
      } catch ({ response }) {
        this.$store.dispatch('progress/reset')
        if (response.status === 422) {
          const { data } = response
          if (data.errors && data.errors.status) {
            this.$set(this.errors, 'status', data.errors.status[0])
          }
        }
      }
    },
    // 楽曲ソート↓クリック
    async onSortDownClicked(index) {
      // 楽曲の入れ替え
      const release = JSON.parse(window.sessionStorage.getItem('album'))
      const productId = release.product.id
      try {
      // サーバ側の更新
        await window.axios.post(`/api/client/products/${productId}/disc/${this.currentDiscIndex}/track/${index}/down`)
        // フロント側更新
        this.currentDiscTracks[index].track_index = index + 1
        this.currentDiscTracks[index + 1].track_index = index
        this.currentDiscTracks.splice(
          index,
          2,
          this.currentDiscTracks[index + 1],
          this.currentDiscTracks[index],
        )
        release.discs[this.currentDiscIndex].tracks = this.currentDiscTracks
        window.sessionStorage.setItem('album', JSON.stringify(release))
        // エラーメッセージの入れ替え
        const bottomError = this.errors[index + 1] || null
        this.errors[`${this.currentDiscIndex}-${index + 1}`] = this.errors[`${this.currentDiscIndex}-${index}`]
        this.errors[`${this.currentDiscIndex}-${index}`] = bottomError

        const bottomLyricsError = this.hasLyricsErrors[`${this.currentDiscIndex}-${index + 1}`]
        this.hasLyricsErrors[`${this.currentDiscIndex}-${index + 1}`] = this.hasLyricsErrors[`${this.currentDiscIndex}-${index}`]
        this.hasLyricsErrors[`${this.currentDiscIndex}-${index}`] = bottomLyricsError
        window.sessionStorage.setItem('hasLyricsError', JSON.stringify(this.hasLyricsErrors))

        const bottomLyricsCompletePercentage = this.lyricsCompletePercentages[`${this.currentDiscIndex}-${index + 1}`]
        this.lyricsCompletePercentages[`${this.currentDiscIndex}-${index + 1}`] = this.lyricsCompletePercentages[`${this.currentDiscIndex}-${index}`]
        this.lyricsCompletePercentages[`${this.currentDiscIndex}-${index}`] = bottomLyricsCompletePercentage
        window.sessionStorage.setItem('lyricsCompletePercentage', JSON.stringify(this.lyricsCompletePercentages))
      } catch ({ response }) {
        this.$store.dispatch('progress/reset')
        if (response.status === 422) {
          const { data } = response
          if (data.errors && data.errors.status) {
            this.$set(this.errors, 'status', data.errors.status[0])
          }
        }
      }
    },
    // 楽曲削除ボタンクリック
    async onDeleteTrackClicked(index) {
      const release = JSON.parse(window.sessionStorage.getItem('album'))
      const productId = release.product.id
      try {
        // サーバ側の更新
        await window.axios.delete(`/api/client/products/${productId}/disc/${this.currentDiscIndex}/track/${index}`)
        // フロント側更新
        this.currentDiscTracks.splice(index, 1)
        let trackIndex = 0
        this.currentDiscTracks.forEach((track, tIndex) => {
          this.currentDiscTracks[tIndex].track_index = trackIndex
          trackIndex += 1
        })
        release.discs[this.currentDiscIndex].tracks = this.currentDiscTracks
        window.sessionStorage.setItem('album', JSON.stringify(release))
        this.releasable = true
        this.errors.releasable = null
      } catch ({ response }) {
        this.$store.dispatch('progress/reset')
        if (response.status === 422) {
          const { data } = response
          if (data.errors && data.errors.status) {
            this.$set(this.errors, 'status', data.errors.status[0])
          }
        }
      }
    },
    // 楽曲アップロードボタンクリック
    onUploadClicked(index) {
      this.uploadTargetIndex = index
      this.$refs.file.value = ''
      this.$refs.file.click()
    },
    // 楽曲アップロードボタンクリック
    onMultiUploadClicked(index) {
      this.uploadTargetIndex = index
      this.isMultiple = (index !== null)
      this.$refs.multiFile.value = ''
      this.$refs.multiFile.click()
    },
    // アップロード完了ハンドラ
    onFileChanged(e) {
      const files = e.target.files || e.dataTransfer.files
      this.uploadFile(files[0])
    },
    // アップロード完了ハンドラ
    onMultiFileChanged(e) {
      const uploadedFiles = e.target.files || e.dataTransfer.files
      const files = []
      if (this.type === 'album') {
        for (let i = 0; i < uploadedFiles.length; i += 1) {
          if (uploadedFiles[i].type.indexOf('audio/') === 0) {
            files.push(uploadedFiles[i])
          }
        }
      } else {
        files.push(uploadedFiles[0])
      }
      this.dragOver = true

      files.sort(
        (file1, file2) => (parseInt(file1.name, 10) - parseInt(file2.name, 10)),
      )
      this.uploadFiles = files
      if (files.length === 0) {
        this.dragOver = false
        this.uploadFiles = []
      }
    },
    async uploadFile(file, totalFiles = 1, currentIndex = 1) {
      this.hasUploadError = false
      const formData = new FormData()
      formData.append('audio', file)
      this.$store.dispatch('progress/updateName', file.name)
      const config = {
        headers: {
          'content-type': 'multipart/form-data',
        },
        onUploadProgress: (progressEvent) => {
          const { loaded, total } = progressEvent
          const progressValue = Math.round((loaded / total) * 100)
          this.$store.dispatch('progress/updateLoaded', progressValue)
          this.$store.dispatch(
            'progress/updateText',
            `${totalFiles}個中の${currentIndex}個目のファイルをアップロード中 (${progressValue}%)`,
          )
        },
      }
      this.$delete(this.errors, `${this.currentDiscIndex}-${this.uploadTargetIndex}`)
      try {
        const release = JSON.parse(window.sessionStorage.getItem('album'))
        const productId = release.product.id
        const response = await window.axios.post(
          `/api/client/products/${productId}/disc/${this.currentDiscIndex}/track/${this.uploadTargetIndex}/upload`,
          formData,
          config,
        )
        const title = response.data.track.titles[0] ? response.data.track.titles[0].title : ''
        this.$set(this.currentDiscTracks[this.uploadTargetIndex], 'title_ja', title)
        this.$set(this.currentDiscTracks[this.uploadTargetIndex], 'audio_file_url', response.data.audio_file_url)
        this.$set(this.currentDiscTracks[this.uploadTargetIndex], 'duration', response.data.duration)

        this.$set(this.currentDiscTracks[this.uploadTargetIndex], 'filename', response.data.filename)
        this.$set(this.currentDiscTracks[this.uploadTargetIndex], 'sample_rate', response.data.track.audio_attributes.sample_rate)
        this.$set(this.currentDiscTracks[this.uploadTargetIndex], 'bit_length', response.data.track.audio_attributes.bits_per_sample)

        // アップロードした楽曲が29秒未満で contentsId がセット済みの場合は無効に。
        if (this.durationToSeconds(response.data.duration) <= 29) {
          const { _restrictions } = this.currentDiscTracks[this.uploadTargetIndex]
          if (_restrictions) {
            _restrictions.filter(restriction => restriction.provider.key === 'youtube')
              .forEach(restriction => {
                if (restriction.settings) {
                  /* eslint-disable no-param-reassign */
                  restriction.settings.contents_enabled = 0
                  restriction.settings.contents_id_enabled = 0
                  /* eslint-enable no-param-reassign */
                }
              })
          }
        }
        release.discs[this.currentDiscIndex].tracks = this.currentDiscTracks
        window.sessionStorage.setItem('album', JSON.stringify(release))
        this.$store.dispatch('progress/reset')
        return true
      } catch ({ response }) {
        this.$store.dispatch('progress/reset')
        if (response.status === 422) {
          this.hasUploadError = true
          const { data } = response
          this.$set(this.errors, `${this.currentDiscIndex}-${this.uploadTargetIndex}`, data.messages)
          this.multiUploadErrors.push({ name: file.name, messages: data.messages })
        }

        return false
      }
    },
    durationToSeconds(duration) {
      if (!duration || duration.split(':').length === 0) {
        return 0
      }
      const [hour, min, sec] = duration.split(':')
      return parseInt(sec, 10) + parseInt(min, 10) * 60 + parseInt(hour, 10) * 60 * 60
    },
    onNextClickedHandle() {
      // Various artistsを未選択で、アーティスト数が５組以上の場合はダイアログを表示
      if (this.artistType === 1 && this.uniqueMainArtists.size >= 5) {
        this.changeVariousArtistsDialogShown = true
      } else if (this.isBtoC) {
        this.checkReleasable()
      } else {
        this.onNextClicked()
      }
      return true
    },
    async checkReleasable() {
      const { data } = await window.axios.get(
        `/api/client/products/${this.product.id}/check-release`,
      )
      this.releasable = data.status
      this.errors.releasable = data.message
      if (this.releasable) {
        this.onNextClicked()
      }
    },
    // 次へボタンクリック
    onNextClicked() {
      window.scrollTo(0, 0)
      this.$router.push({ name: `${this.$route.meta.sideMenuId}-step3` })
    },
    // 次へボタンの無効化状態
    nextButtonDisabled() {
      if (this.$store.state.auth.permission === 10) {
        // 上級管理者ならばチェックを迂回
        return !(this.discs.some(disc => disc.tracks.length > 0))
      }
      // アップロードデータに問題がある
      if (this.hasUploadError) {
        return true
      }
      if (Object.values(this.hasLyricsErrors).some(e => e)) return true
      // サブスクリプションの決済に問題がある
      if (this.subscriptionDefaulted) return true
      // ジャケットが登録されていない
      if (!this.jacketImage) {
        return true
      }
      // リリース情報が登録されてない
      if (this.product.is_draft > 1) {
        return true
      }
      // メインアーティストの数が条件を満たしていない
      if (!this.isSatisfyMainArtists) {
        return true
      }
      const minTrack = this.type === 'album' ? 2 : 1
      // 楽曲に楽曲ファイルがセットされているかどうか
      let totalTracks = 0
      let missingTracks = false
      let missingFile = false
      let missingTrackInfo = false
      let missingTrackMonetize = false
      let missingTrackRoles = false
      const bitLength = new Set()
      this.discs.forEach(disc => {
        totalTracks += disc.tracks.length
        if (disc.tracks.length < minTrack) {
          missingTracks = true
        }
        disc.tracks.forEach(track => {
          // すべての楽曲に楽曲ファイルがセットされている
          if (!track.filename) {
            missingFile = true
          }
          if (!track.title_kana
            || track.copyright_artists.length === 0
            || !track.copyright_artists[0].name_ja) {
            missingTrackInfo = true
          }
          // BtoC は役割が必要
          if (this.isBtoC && track.role_assignments?.length === 0) {
            missingTrackRoles = true
          }
          // eslint-disable-next-line no-underscore-dangle
          if (track._restrictions) {
            // eslint-disable-next-line no-underscore-dangle
            track._restrictions.forEach(restriction => {
              if ([this.product.genre1, this.product.genre2].some(genre => genre === 'Spoken Word')
               && restriction.settings
               && (restriction.settings.contents_id_enabled ?? 0) === 1) {
                missingTrackMonetize = true
              }
            })
          }
          bitLength.add(track.bit_length)
        })
      })
      // 楽曲が0件
      if (totalTracks === 0) {
        return true
      }
      // アルバムは4曲以上
      if (missingTracks) {
        return true
      }
      // 楽曲のタイトルに抜け
      if (missingTrackInfo) {
        return true
      }
      // ジャンルがSpoken Wordで YouTubeマネタイズサービス利用
      if (missingTrackMonetize) {
        return true
      }
      // 役割
      if (missingTrackRoles) {
        return true
      }
      // 複数のビットレートが存在
      if (bitLength.size > 1) {
        return true
      }
      if (!this.releasable) {
        return true
      }
      // 61秒未満の楽曲がある場合（追加ストア申請はスキップ・narasu以外はスキップ）
      if (this.isBtoC && !this.isAppendDspRequest) {
        const hasShortTrack = this.discs.some(disc => disc.tracks.some((track) => {
          if (!track.duration) return false
          const parts = track.duration.split(':')
          const h = parseInt(parts[0], 10) || 0
          const m = parseInt(parts[1], 10) || 0
          const s = parseInt(parts[2], 10) || 0
          return h * 3600 + m * 60 + s < 61
        }))
        if (hasShortTrack) return true
      }
      return missingFile
    },
    // 言語コード変換
    getLanguageName(value) {
      return this.languages[value]
    },
    // 著作権団体コード変換
    getCopyrightGroupName(value) {
      return this.copyrightGroups[value]
    },
    // Featuringの接続表記コード変換
    getFeaturingPrefixName(value) {
      return this.featuringPrefixes[value]
    },
    getCopyrightRoleName(roles) {
      const roleNames = []
      if (roles.indexOf('lyricist') !== -1) {
        roleNames.push('作詞')
      }
      if (roles.indexOf('composer') !== -1) {
        roleNames.push('作曲')
      }
      if (roles.indexOf('arranger') !== -1) {
        roleNames.push('編曲')
      }
      return roleNames.join('、')
    },
    // 役割カタログ（パフォーマンス／プロダクション＆エンジニアリング）の読み込み
    async fetchRoleCatalog() {
      try {
        const { data } = await window.axios.get('/api/client/role-assignments/catalog')
        this.performanceRoleLabels = this.buildRoleLabelMap(data.performance_roles)
        this.productionRoleLabels = this.buildRoleLabelMap(data.production_roles)
      } catch (e) {
        this.performanceRoleLabels = {}
        this.productionRoleLabels = {}
      }
    },
    // 役割カタログ配列から key => 日本語ラベル のマップを作成
    buildRoleLabelMap(roles) {
      const map = {}
      if (Array.isArray(roles)) {
        roles.forEach(role => {
          if (role && role.key) {
            map[role.key] = (role.labels && role.labels.ja) ? role.labels.ja : role.key
          }
        })
      }
      return map
    },
    // 役割キー配列を日本語ラベルの文字列に変換
    getRoleLabels(roleKeys, type) {
      const labelMap = type === 'performance' ? this.performanceRoleLabels : this.productionRoleLabels
      if (!Array.isArray(roleKeys)) {
        return ''
      }
      return roleKeys.map(key => labelMap[key] || key).join('、')
    },
    // 指定カテゴリ（performance / production）の役割を持つアーティストを
    // 「氏名（役割、…）」形式で連結した文字列を返す（該当なしは空文字）
    getCategoryRoleAssignments(track, type) {
      if (!track.role_assignments || !Array.isArray(track.role_assignments)) {
        return ''
      }
      const rolesKey = type === 'performance' ? 'performance_roles' : 'production_roles'
      return track.role_assignments
        .filter(assignment => Array.isArray(assignment[rolesKey])
          && assignment[rolesKey].length > 0)
        .map(assignment => `${assignment.name_ja}（${this.getRoleLabels(assignment[rolesKey], type)}）`)
        .join('、')
    },
    getTrackClassificationName(value) {
      switch (value) {
        case 1:
          return 'オリジナル'
        case 2:
          return 'カバー'
        case 3:
          return 'アレンジ'
        case 4:
          return 'パブリックドメイン'
        default:
          return ''
      }
    },
    getTrackYoutubeContentId(track) {
      if (track.classification !== 1) return '利用しない'

      const { _restrictions } = track
      if (_restrictions) {
        let idEnabled = 0
        let enabled = 0
        _restrictions.filter(restriction => restriction.provider.key === 'youtube')
          .forEach(restriction => {
            if (restriction.settings) {
              enabled = restriction.settings.contents_enabled
              idEnabled = restriction.settings.contents_id_enabled
            }
          })

        if (idEnabled === 0 || idEnabled === '') return '利用しない'
        if (this.isBtoC) return '利用する'
        return enabled === 0 ? '利用する' : '配信 + 利用'
      }
      return false
    },
    getFeaturingArtistsNames(track) {
      if (track && track.featuring_artists.length > 0) {
        let featString = this.getFeaturingPrefixName(track.featuring_artists[0].prefix)
        track.featuring_artists.forEach((artist, index) => {
          if (index >= 1) featString += ' ,'
          featString += ` ${artist.name_ja}`
        })
        return featString
      }
      return ''
    },
    onPlayStart(url) {
      this.currentPlayAudioUrl = url
    },
    onFileDragover(event) {
      if (!this.enableAddTracks || this.trackRegisterDisabled) {
        return
      }
      // eslint-disable-next-line no-param-reassign
      event.dataTransfer.dropEffect = 'copy'
      this.dragOver = true
    },
    onFileDragleave() {
      this.dragOver = false
    },
    onFileDrop(event) {
      const files = []
      for (let i = 0; i < event.dataTransfer.files.length; i += 1) {
        if (event.dataTransfer.files[i].type.indexOf('audio/') === 0) {
          files.push(event.dataTransfer.files[i])
        }
      }
      files.sort(
        (file1, file2) => (parseInt(file1.name, 10) - parseInt(file2.name, 10)),
      )

      this.uploadFiles = files

      if (files.length === 0) {
        this.dragOver = false
        this.uploadFiles = []
      }
    },
    onOutsideFileDrop() {
      if (!this.uploadFiles.length) {
        this.dragOver = false
      }
    },
    onUploadCancelClicked() {
      this.dragOver = false
      this.uploadFiles = []
    },
    async onUploadFilesClicked() {
      this.hideDropZone = true
      this.dragOver = false
      this.multiUploadErrors = []
      let hasErrors = false
      const hasVariousArtist = this.artists.filter(artist => artist.type === 2).length > 0
      for (let i = 0; i < this.uploadFiles.length; i += 1) {
        // eslint-disable-next-line camelcase
        const title_ja = this.isBtoC && this.type === 'single' ? this.product.title_ja : this.uploadFiles[i].name.replace('.wav', '')
        this.uploadTargetIndex = this.currentDiscTracks.length
        this.$set(this.discs[this.currentDiscIndex].tracks, this.uploadTargetIndex, {
          title_ja,
          track_index: this.uploadTargetIndex,
          version_ja: null,
          main_artists: hasVariousArtist
            ? [{ name_ja: '', name_kana: '', name_en: '' }]
            : this.mainArtists,
          featuring_artists: [],
          copyright_artists: [],
          filename: null,
          vocal: 1,
          parental_warning: 'no-explicit',
          language: 'ja',
          copyright_group: '7',
          prefix: '3',
          trial_start_min: 0,
          trial_start_sec: 0,
          is_omnibus: 0,
        })
        this.$store.dispatch('progress/updateLoaded', 0)
        // eslint-disable-next-line no-await-in-loop
        const result = await this.uploadFile(this.uploadFiles[i], this.uploadFiles.length, i + 1)
        if (!result) {
          this.$delete(this.discs[this.currentDiscIndex].tracks, this.uploadTargetIndex)
          this.$delete(this.errors, `${this.currentDiscIndex}-${this.uploadTargetIndex}`)
          hasErrors = true
        }
      }
      if (hasErrors) {
        this.validateTracksDialogShown = true
        this.$store.dispatch('progress/reset')
      }
      const release = JSON.parse(window.sessionStorage.getItem('album'))
      release.discs[this.currentDiscIndex].tracks = this.currentDiscTracks
      window.sessionStorage.setItem('album', JSON.stringify(release))
      this.dragOver = false
      this.uploadFiles = []
      this.hideDropZone = false
    },
    hasConfirmationTrackErrors(index) {
      return this.confirmTrackErrors[this.currentDiscIndex]
        && Object.keys(this.confirmTrackErrors[this.currentDiscIndex]).length
        && this.confirmTrackErrors[this.currentDiscIndex][index]
        && Object.keys(this.confirmTrackErrors[this.currentDiscIndex][index]).length
    },
    getUniqueMainArtists() {
      const artists = new Set()
      this.discs.forEach(disc => {
        disc.tracks.forEach(track => {
          track.main_artists.forEach(mainArtist => {
            artists.add(mainArtist.name_ja)
          })
        })
      })
      return artists
    },
    validateSatisfyMainArtists() {
      this.uniqueMainArtists = this.getUniqueMainArtists()
      if (this.artistType === 2) {
        if (this.uniqueMainArtists.size <= 4) {
          return false
        }
      }
      return true
    },
    async onChangeVariousArtistsDialog() {
      const { data } = await window.axios.put(`/api/client/products/${this.product.id}/change-various-artists`)
      const release = JSON.parse(window.sessionStorage.getItem('album'))
      release.artistType = 2
      release.product.artist_name = 'Various Artists'
      release.artists = [data.id]
      const discs = release.discs || [{ tracks: [] }]
      for (let i = 0; i < discs.length; i += 1) {
        for (let n = 0; n < discs[i].tracks.length; n += 1) {
          discs[i].tracks[n].is_omnibus = true
        }
      }
      release.discs = discs
      window.sessionStorage.setItem('album', JSON.stringify(release))
      this.onNextClicked()
    },
    formatHz(bytes, decimals = 2) {
      if (bytes === 0) return '0 Hz'

      const k = 1000
      const dm = decimals < 0 ? 0 : decimals
      const sizes = ['Hz', 'KHz', 'MHz', 'GHz', 'THz', 'PHz', 'EHz', 'ZHz', 'YHz']

      const i = Math.floor(Math.log(bytes) / Math.log(k))

      return `${parseFloat((bytes / (k ** i)).toFixed(dm))} ${sizes[i]}`
    },
    onSubscriptionCarrierFeePendingClicked() {
      this.$router.push({ name: 'settlement-method-change' })
    },
    getRightsFileNames(docs) {
      const fileNames = []

      docs.forEach(doc => {
        if (doc.images.length === 0) return
        doc.images.forEach(image => {
          fileNames.push(image.name)
        })
      })

      if (fileNames.length === 0) return ''
      return `(${fileNames.join(',')})`
    },
    hasShortDurationError(trackIndex) {
      if (!this.isBtoC || this.status !== 0 || this.isAppendDspRequest) return false
      const track = this.currentDiscTracks[trackIndex]
      if (!track || !track.duration) return false
      const parts = track.duration.split(':')
      const h = parseInt(parts[0], 10) || 0
      const m = parseInt(parts[1], 10) || 0
      const s = parseInt(parts[2], 10) || 0
      return h * 3600 + m * 60 + s < 61
    },
    hasLyricsError(trackIndex = null) {
      if (trackIndex === null) {
        return Object.values(this.hasLyricsErrors).some(e => e)
      }
      return this.hasLyricsErrors[`${this.currentDiscIndex}-${trackIndex}`]
    },
    getLyricsCompletePercentage(trackIndex) {
      return this.lyricsCompletePercentages[`${this.currentDiscIndex}-${trackIndex}`]
    },
  },
}
</script>

<style scoped>
.track-error {
  text-align: center;
  padding-top: 2vmin;
  padding-bottom: 5vmin;
  color: #ef3c3c;
}

.bit-depth-error {
  text-align: center;
  padding-top: 2vmin;
  padding-bottom: 0vmin;
  color: #ef3c3c;
}

@media screen and (min-width: 896px) {
  .preview-image {
    width: 240px;
    height: 240px;
  }
}

@media screen and (max-width: 895px) {
  .preview-image {
    width: 50vw;
    height: 50vw;
  }
}

@media screen and (max-width: 895px) {
  .c-gray-box__caption {
    text-align: left;
  }
}

@media screen and (max-width: 895px) {
  .release-status-area__tab-box {
    overflow-x: auto;
    white-space: nowrap;
  }
}

.release-status-area__tab {
  position: relative;
  width: 100%;
}

@media screen and (min-width: 896px) {
  .release-status-area__tab {
    align-items: center;
    display: flex;
    justify-content: flex-start;
    margin: 30px 0 0px;
  }
}

@media screen and (max-width: 895px) {
  .release-status-area__tab {
    margin-top: 2.66667vw;
  }
}
.release-status-area__tab-item {
  background-color: #bcb7b3;
  display: inline-block;
  font-weight: bold;
  position: relative;
}

@media screen and (min-width: 896px) {
  .release-status-area__tab-item {
    height: 52px;
    margin: 8px 8px 8px 0;
    width: 100px;
  }
}

@media screen and (max-width: 895px) {
  .release-status-area__tab-item {
    height: 9.6vw;
    margin: 0 2px 0 0;
    width: 24vw;
  }
}

.release-status-area__tab-item a {
  align-items: center;
  color: #ffffff;
  cursor: pointer;
  display: flex;
  font-weight: normal;
  height: 100%;
  justify-content: center;
  width: 100%;
}

@media screen and (min-width: 896px) {
  .release-status-area__tab-item a {
    font-size: 18px;
  }
}

@media screen and (max-width: 895px) {
  .release-status-area__tab-item a {
    font-size: 2.93333vw;
  }
}

.release-status-area__tab-item.current {
  background: #e5e0d8;
}

@media screen and (min-width: 896px) {
  .release-status-area__tab-item.current {
    height: 68px;
    margin: 0 8px 0 0;
  }
}

@media screen and (max-width: 895px) {
  .release-status-area__tab-item.current {
    height: 11.73333vw;
    margin: 0 2px 0 0;
  }
}

.release-status-area__tab-item.current a {
  color: #333333;
}

@media screen and (min-width: 896px) {
  .release-status-area__tab-item.current a {
    padding-right: 10px;
  }
}

.release-status-area__tab-item.current a .release-status-area__tab-item--accordion {
  display: block;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}

@media screen and (min-width: 896px) {
  .release-status-area__tab-item.current a .release-status-area__tab-item--accordion {
    height: 20px;
    right: 6px;
    width: 20px;
  }
}

@media screen and (max-width: 895px) {
  .release-status-area__tab-item.current a .release-status-area__tab-item--accordion {
    height: 5.33333vw;
    right: 2.13333vw;
    width: 5.33333vw;
  }
}

.release-status-area__tab-item.current a .release-status-area__tab-item--accordion span {
  border: 2px solid #ff6c00;
  border-radius: 50%;
  display: block;
  height: 100%;
  position: relative;
  position: relative;
  width: 100%;
}

.release-status-area__tab-item.current a .release-status-area__tab-item--accordion span:before {
  background-color: #ff6c00;
  content: "";
  left: 50%;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  transition: 0.3s;
}

@media screen and (min-width: 896px) {
  .release-status-area__tab-item.current a .release-status-area__tab-item--accordion span:before {
    height: 2px;
    width: 8px;
  }
}

@media screen and (max-width: 895px) {
  .release-status-area__tab-item.current a .release-status-area__tab-item--accordion span:before {
    height: 0.53333vw;
    width: 2.13333vw;
  }
}

.release-status-area__tab-item.add {
  background: #ffffff;
  border: solid 1px #bcb7b3;
}

@media screen and (min-width: 896px) {
  .release-status-area__tab-item.add {
    height: 52px;
    margin: 0 8px 0 0;
    width: 75px;
  }
}

@media screen and (max-width: 895px) {
  .release-status-area__tab-item.add {
    height: 9.6vw;
    margin: 0 2px 0 0;
  }
}

.release-status-area__tab-item.add a {
  color: #333333;
}

@media screen and (min-width: 896px) {
  .release-status-area__tab-item.add a {
    font-size: 14px;
    padding-right: 10px;
  }
}

.release-status-area__tab-item.add a .release-status-area__tab-item--accordion {
  display: block;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}

@media screen and (min-width: 896px) {
  .release-status-area__tab-item.add a .release-status-area__tab-item--accordion {
    height: 20px;
    right: 5px;
    width: 20px;
  }
}

@media screen and (max-width: 895px) {
  .release-status-area__tab-item.add a .release-status-area__tab-item--accordion {
    height: 5.33333vw;
    right: 0.93333vw;
    width: 5.33333vw;
  }
}

.release-status-area__tab-item.add a .release-status-area__tab-item--accordion span {
  border: 2px solid #ff6c00;
  border-radius: 50%;
  display: block;
  height: 100%;
  position: relative;
  position: relative;
  width: 100%;
}

.release-status-area__tab-item.add a .release-status-area__tab-item--accordion span:before {
  background-color: #ff6c00;
  content: "";
  left: 50%;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  transition: 0.3s;
}

@media screen and (min-width: 896px) {
  .release-status-area__tab-item.add a .release-status-area__tab-item--accordion span:before {
    height: 2px;
    width: 8px;
  }
}

@media screen and (max-width: 895px) {
  .release-status-area__tab-item.add a .release-status-area__tab-item--accordion span:before {
    height: 0.53333vw;
    width: 2.66667vw;
  }
}

.release-status-area__tab-item.add a .release-status-area__tab-item--accordion span:after {
  background-color: #ff6c00;
  content: "";
  left: 50%;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%) rotate(90deg);
  transition: 0.3s;
}

@media screen and (min-width: 896px) {
  .release-status-area__tab-item.add a .release-status-area__tab-item--accordion span:after {
    height: 2px;
    width: 8px;
  }
}

@media screen and (max-width: 895px) {
  .release-status-area__tab-item.add a .release-status-area__tab-item--accordion span:after {
    height: 0.53333vw;
    width: 2.13333vw;
  }
}

.multiple-disc-line {
  border-bottom: solid;
  border-color: #e5e0d8;
}

@media screen and (min-width: 896px) {
  .multiple-disc-line {
    width: 1080px;
    transform: translateX(-3.7%);
    border-width: 5px;
  }
}

@media screen and (max-width: 895px) {
  .multiple-disc-line {
    transform: translateX(-6%);
    margin-top: -1px;
    width: 89.3vw;
    border-width: 2px;
  }
}

.disable-link {
  pointer-events: none;
}

.drop-zone {
  background: rgba(0, 0, 0, 0.8);
  left: 0;
  position: fixed;
  top: 0;
  z-index: 3;
  height: 100vh;
  width: 100vw;
}

.release-song-add-area__upload-box {
    align-items: center;
    background-color: #ffffff;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    position: relative;
}

@media screen and (min-width: 896px) {
  .release-song-add-area__upload-box {
    border: dotted 3px #bcb7b3;
    height: 190px;
    margin: 0 auto 40px;
    padding-bottom: 40px;
    padding-left: 160px;
    padding-right: 160px;
    padding-top: 30px;
    width: 680px;
  }
}

.release-song-add-area__upload-box--on {
  z-index: 4;
  border: solid 3px #ff6c00;
}

.release-upload-btn-wrap {
  display: flex;
}

@media screen and (min-width: 896px) {
  .release-upload-btn-wrap .c-btn {
    font-size: 1.5rem;
    min-width: 176px;
    padding: 9px 25px;
  }
}

@media screen and (max-width: 895px) {
  .release-upload-btn-wrap .c-btn {
    width: 50%;
  }
}

@media screen and (max-width: 895px) {
  .release-upload-btn-wrap .c-btn--back {
    padding: 2.66666vw 7.33333vw;
  }
}

@media screen and (max-width: 895px) {
  .release-upload-btn-wrap span {
    white-space: nowrap
  }
}
.upload-file-word-break {
  word-break: break-all;
}
.release-info-wrapper.reverse{
  display: flex;
  flex-direction: column-reverse;
  margin-top: 30px;
}

.lyric-button-disabled {
  background-color: #bcb7b3;
  pointer-events: none;
}
.release-notice-lyrics-disabled {
  margin: 2px auto 0;
  text-align: center;
  color: #5c5c5c;
}

@media screen and (min-width: 895px) {
  .upload-button-album {
    width: 640px;
  }
  .upload-button-single {
    width: 420px;
  }
  .edit-button-album {
    width: 200px;
  }
  .edit-button-single {
    width: 200px;
  }
  .delete-button {
    width: 200px;
  }
  .lyric-button {
    width: 200px;
  }
  .release-notice-lyrics-disabled {
    font-size: 15px;
  }
  .explain-high-resolution {
      margin-top: 20px;
  }
}
@media screen and (max-width: 895px) {
  .upload-button-single, .upload-button-album {
    width: 100%;
  }
  .edit-button-single {
    width: 35vw;
    margin-left: 0;
  }
  .edit-button-album {
    width: 35vw;
    margin-left: 0;
  }
  .delete-button {
    width: 35vw;
  }
  .lyric-button {
    width: 35vw;
    margin-right: 0;
  }
  .release-notice-lyrics-disabled {
    font-size: 13px;
    margin-right: 0;
  }
  .explain-high-resolution {
      margin-top: spvw(20);
  }
}

.release-status-area__item-direction-btn-wrap .c-btn-release{
  justify-content: center;
}

.lyrics-view-entry {
  padding: 16px 0;
}

@media screen and (min-width: 895px) {
}
</Style>
